import React, { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import styles from "../POIList/POIList.module.css";
import {
    DefaultButton,
    PrimaryButton,
    IStackTokens,
    Dialog,
    DialogType,
    DialogFooter,
} from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import strings from "../../../loc/strings";

initializeIcons();

const stackTokens: IStackTokens = { childrenGap: 20 };

function ConfirmDialog(props: any) {
    const auth = useAuth();

    const handleSubmit = (event: any) => {
        event.preventDefault();
    }

    const handleDialogCloseConfirm = () => {
        props.handleActionExist('existsClose');
        props.setDialogIsHiddenConfirm(true);
    };

    const handleDialogSaveConfirm = () => {
        props.handleActionExist('existsSave');
        props.setDialogIsHiddenConfirm(true);
    };

    // Dialog Edit Contac
    const dialogContentPropsEdit = {
        type: DialogType.normal,
        title: props.title,
    };

    const modalPropsEdit = React.useMemo(
        () => ({
            isBlocking: true,
            className: "ContactConfirm"
        }),
        [],
    );

    return (
        <div className="ContacExists">
            <Dialog
                hidden={props.dialogIsHiddenConfirm}
                onDismiss={handleDialogCloseConfirm}
                dialogContentProps={dialogContentPropsEdit}
                modalProps={modalPropsEdit}
                minWidth="560px"
            >
                <div>
                    <p>
                        {(props.isAdd ? (
                            <>A new contact will be added. Are you sure you want to continue?</>
                        )
                            : (
                                <>Contact details will be updated. Are you sure you want to continue?</>
                            )
                        )}
                    </p>
                </div>
                <DialogFooter>
                    <PrimaryButton data-testid="save-confirm" onClick={handleDialogSaveConfirm} text="Save" />
                    <DefaultButton onClick={handleDialogCloseConfirm} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </div>

    );
}

export default ConfirmDialog;